<div class="landing-ad-container landing-ad-bottom" id="bottom-promotions" *ngIf="showLowerAds()">
    <ng-container *ngFor="let ad of [bottomLeftAd, bottomRightAd]; trackBy: trackByFn">
        <a *ngIf="!!ad" (click)="sendAdPromotionClick(ad)" [href]="ad.adLink"
           [class]="ad.type" [attr.data-promo]="ad.name">
            <img class="img-fluid" [src]="ad?.images[0]?.imagePath" alt=""/>
            <div class='image-title-description'>
                <h2 class="heading-3">{{ ad.imageTitle }}</h2>
                <p>{{ ad.imageDescription }}</p>
            </div>
        </a>
    </ng-container>
</div>
